<template>
    <div class="mediacentre__item -bg-white">
        <div class="item__wrapper">
            <div class="item__image content-item module-image" @click.stop="handleOverlayOpen()">
                <div class="module-image-preloaded -no-alpha -loaded">
                    <div class="image-preloaded__image" v-if="item.image">
                        <div class="image-preloaded__placeholder">
                            <div class="img" style="padding-bottom: calc((480/850) * 100%)" :data-img-src="item.image.split('|')[0]" :data-img-alt="item.image.split('|')[2]" :data-img-title="item.image.split('|')[1]"></div>
                        </div>
                        <div class="image-preloaded__loaded">
                            <img :src="item.image.split('|')[0]" :title="item.image.split('|')[1]" :alt="item.image.split('|')[2]" class="-loaded">
                        </div>
                        <div class="image-preloaded__video" v-if="item.video">
                            <div class="video__cta">
                                <div class="cta__button">
                                    <svg width="11" height="16" viewBox="0 0 11 16" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M1 1.5V15l10-7L1 1z" fill="#FFF" stroke="#FFF" fill-rule="evenodd" stroke-linejoin="round"></path>
                                    </svg>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="item__content">
                <div class="content__headline">
                    <span class="heading zeta -color-text-alpha">{{ item.name }}</span>
                </div>
                <div class="content__text">
                    <p class="meta">{{ item.text }}</p>
                </div>
            </div>
        </div>
        <div class="module-overlay module-overlay--video -open" v-if="overlayOpen">
            <div class="overlay__overlay">
                <div class="overlay__background" @click.stop="overlayOpen = !overlayOpen"></div>
                <div class="overlay__content">
                    <div class="overlay__close" @click.stop="overlayOpen = !overlayOpen"></div>
                    <div class="content-wrapper">
                        <template v-if="item.videoType === 'html5'">
                            <video width="640" height="360" autoplay controls playsInline webkit-playsinline>
                                <source :src="item.video" type="video/mp4">
                            </video>
                        </template>
                        <template v-else>
                            <iframe :src="videoSrc + item.video + '?autoplay=1&amp;loop=1' + additionalVideoParams" width="640" height="360" frameborder="0" allow="autoplay; fullscreen" allowfullscreen=""></iframe>
                        </template>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'Item',
    data ()
    {
        return {
            videoSrc: window.app.mediacentre_list.video_src,
            additionalVideoParams: window.app.mediacentre_list.additional_video_params,
            overlayOpen: false
        }
    },
    methods: {
        handleOverlayOpen: function ()
        {
            this.overlayOpen = !this.overlayOpen
            if (window && window.dataLayer)
            {
                window.dataLayer.push({
                    'vimeo-video': this.item.name,
                    'event': 'vimeo-start-event'
                })
            }
        }
    },
    props: ['item']
}
</script>
